import { getPayloadFromToken } from "./redux/modules/auth/utils";
import store from "./redux/storeInstance";
import pkg from "../package.json";
import * as fakeGcps from "./apiFacades/bapi/fakeGcps";
import { displayFatalError } from "./redux/modules/fatalError/reducer";

/* tslint:disable:no-console */
console.log(`GCP App v${pkg.version}`);

(window as any).store = store;
(window as any).getPayloadFromToken = getPayloadFromToken;
(window as any).displayFatalError = displayFatalError;

(window as any).apiFacades = {
  bapi: {
    fakeGcps,
  },
};
